import { ListPlus } from "lucide-react";
import type {
  ActionNodeReturnOrderAttributeConfigDto,
  WorkflowV2NodeDto,
} from "@babackapp/private-api-client/types";
import { NodeCategory, registerNode } from "../../lib/register-node";
import { ReturnOrderAttributeActionNodeEditor } from "./editor";
import { ReturnOrderAttributeActionNodePanel } from "./panel";

const newNodeDefaultValue = {
  actionType: "set_order_attribute",
  config: {
    name: "",
    value: "",
  } satisfies ActionNodeReturnOrderAttributeConfigDto,
};

export default registerNode<ActionNodeReturnOrderAttributeConfigDto>({
  type: "action:set_order_attribute",
  name: "workflowsEditor.nodes.setOrderAttribute.title",
  description: "workflowsEditor.nodes.setOrderAttribute.description",
  Icon: ListPlus,
  category: NodeCategory.ACTION,
  color: "blue",
  editor: {
    component: ReturnOrderAttributeActionNodeEditor,
  },
  configPanel: {
    component: ReturnOrderAttributeActionNodePanel,
  },
  // Extended action type outside the generated V2 union (return engine).
  newNodeDefaultData: newNodeDefaultValue as unknown as WorkflowV2NodeDto["data"],
});

export { ReturnOrderAttributeActionNodeEditor } from "./editor";
export { ReturnOrderAttributeActionNodePanel } from "./panel";
